import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import usePostData from 'hooks/usePostData';

const PrivateRoute = () => {
  const { res, error, postData } = usePostData();
  const [isAuthenticated, setIsAuthenticated] = useState();
  const [currentUser, setCurrentUser] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    postData('user/userFindOne', {});
  }, []);

  useEffect(() => {
    if (error) window.location.href = '/login';
    if (res) {
      setLoaded(true);
      setCurrentUser(res);
      setIsAuthenticated(true);
    }
  }, [res, error]);

  return (
    <>
      {loaded && isAuthenticated ? (
        <Dashboard currentUser={currentUser} />
      ) : (
        loaded && !isAuthenticated && <Navigate to="/login" />
      )}
    </>
  );
};
export default PrivateRoute;
